import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEqual } from 'lodash';
import { Modal } from 'react-bootstrap';
import { titleize } from 'underscore.string';
import Alert from 'components/ui/Alert';
import { withTranslation } from 'react-i18next';
import { sluggify } from 'utils/localization/utils';
import ChangeUser from './ChangeUser';
const getInitialState = (props) => {
    return {
        jobs: props.jobs || [],
    };
};
class ChangeUserModal extends Component {
    constructor(props) {
        super(props);
        this._isMounted = false;
        this.onHide = () => {
            const state = Object.assign(Object.assign({}, getInitialState(this.props)), { user: null, editing: false });
            this.setState(state, () => {
                this.props.onHide();
            });
        };
        this.handleSelectUser = (item, user) => {
            const isCarrierTrained = user._type === 'Carrier' ? user.status === 'Trained' : true;
            this.setState({ user, isCarrierTrained, editing: true });
        };
        this.handleJobRemove = (job) => {
            const currentJobs = this.state.jobs;
            const jobs = currentJobs.filter((e) => e._id !== job._id);
            this.setState({ jobs, editing: true });
        };
        this.handleSave = async () => {
            const { jobs, user } = this.state;
            const { isShipper } = this.props;
            if (jobs.length > 0 && user) {
                if (!isShipper && user.is_broker && this.props.onAssignBrokerCarrier) {
                    this.props.onAssignBrokerCarrier(jobs, user);
                }
                else {
                    try {
                        this.setState({ saving: true });
                        await this.props.onSave(user, jobs);
                        this.onHide();
                    }
                    catch (e) {
                        // failed toast already rendered
                    }
                    finally {
                        if (this._isMounted) {
                            this.setState({ saving: false });
                        }
                    }
                }
            }
        };
        this.state = Object.assign(Object.assign({}, getInitialState(props)), { editing: false, user: null, isCarrierTrained: true });
    }
    componentDidMount() {
        this._isMounted = true;
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    UNSAFE_componentWillReceiveProps(props) {
        const currentJobs = (this.props.jobs || []).map((job) => job._id);
        const nextJobs = (props.jobs || []).map((job) => job._id);
        const jobsChanged = !isEqual(currentJobs, nextJobs);
        if (jobsChanged || !this.state.editing) {
            this.setState((prevState) => {
                const { user, editing } = prevState;
                return Object.assign(Object.assign({}, getInitialState(props)), { user,
                    editing });
            });
        }
    }
    confirmationMessage() {
        const { jobs, user, isCarrierTrained } = this.state;
        const { t } = this.props;
        if (jobs.length > 0 && user && isCarrierTrained) {
            const name = this.props.type === 'shipper' ? user.company_name : user.name;
            const message = t('CLICK_SAVE_TO_CHANGE_JOBS', {
                jobsCount: jobs.length,
                name,
            });
            return React.createElement(Alert, { dataTestId: "Alert-7de989e3", type: "info", title: message });
        }
        if (jobs.length > 0 && user && !isCarrierTrained) {
            return (React.createElement(Alert, { dataTestId: "Alert-c9cdff50", type: "error", title: t('CARRIER_IS_NOT_TRAINED') }));
        }
        return null;
    }
    render() {
        const { t } = this.props;
        const saveDisabled = !(this.state.jobs.length &&
            this.state.user &&
            this.state.isCarrierTrained);
        return (React.createElement(Modal, { show: this.props.show, onHide: () => this.onHide(), enforceFocus: false },
            React.createElement(Modal.Header, { "data-testid": "ModalHeader-684a4fab", closeButton: true },
                React.createElement(Modal.Title, { "data-testid": "ModalTitle-a788667a" }, t('CHANGE_USER_TYPE', {
                    type: titleize(t(sluggify(this.props.type))),
                }))),
            React.createElement(Modal.Body, { "data-testid": "ModalBody-7f6680a3" },
                React.createElement(ChangeUser, { type: this.props.type, jobs: this.state.jobs, onRemoveJob: this.handleJobRemove, onSelectUser: this.handleSelectUser, isShipper: this.props.isShipper })),
            React.createElement(Modal.Footer, { "data-testid": "ModalFooter-43b4cd79" },
                React.createElement("div", { "data-testid": "div-5588116e", className: "flex" },
                    React.createElement("div", { "data-testid": "div-1e50c4e3", className: "w-3/4 text-left ml-2" }, this.confirmationMessage()),
                    React.createElement("div", { "data-testid": "div-ecdd992a", className: "w-1/4 mt-3" },
                        React.createElement("div", { "data-testid": "div-7b7d7ac2", className: "flex justify-end button-group" },
                            React.createElement("button", { "data-testid": "button-45bce920", className: "block button secondary-action", onClick: () => this.onHide() }, t('CANCEL')),
                            React.createElement("button", { "data-testid": "button-f695319b", className: "block mr-2 button button-green unified-masterList-assignCarrier heap", disabled: saveDisabled || this.state.saving, onClick: this.handleSave }, this.state.saving ? t('SAVING') : titleize(t('SAVE')))))))));
    }
}
ChangeUserModal.propTypes = {
    show: PropTypes.bool.isRequired,
    jobs: PropTypes.array,
    type: PropTypes.oneOf(['shipper', 'carrier', 'consignee']).isRequired,
    onSave: PropTypes.func.isRequired,
    onHide: PropTypes.func.isRequired,
    isShipper: PropTypes.bool,
};
export default withTranslation()(ChangeUserModal);
